import {injectable} from "tsyringe";
import {UpdateKnowledgeObjectMetadataCommand, UpdateKnowledgeObjectMetadataPayload} from "../commands/update-knowledge-object-metadata.command";
import {transformer} from "../decorators/transformer.decorator";
import {DataTransferObject} from "../domain/dtos/data-transfer-object.interface";
import {AbstractCommandToDtoTransformer} from "./abstract-command-to-dto.transformer";

/**
 * Maps `UpdateKnowledgeObjectMetadataCommand` to the backend command DTO.
 *
 * The payload here is a plain `{ objectUid, title }` value object — NOT a
 * proxified entity — so the generic command-to-dto fallback (which insists on
 * a ChangeTracker proxy, see `TransformerHelper.getTransformer()`) does not
 * apply; without this dedicated transformer, submitting a rename throws
 * "The payload of the command must be a proxified object." (found 2026-08-17,
 * same payload-shape reasoning as the sibling
 * `save-knowledge-object-content-command-to-dto.transformer.ts`). Backend
 * handler reads `payload.objectUid` (ShortId or UUID) and `payload.title`.
 */
@injectable()
@transformer({
    source: UpdateKnowledgeObjectMetadataCommand,
    target: `dto`
})
export class UpdateKnowledgeObjectMetadataCommandToDtoTransformer extends AbstractCommandToDtoTransformer<UpdateKnowledgeObjectMetadataPayload> {

    protected async toDTO(payload: UpdateKnowledgeObjectMetadataPayload): Promise<DataTransferObject> {
        return {
            objectUid: payload.objectUid,
            title: payload.title,
        } as unknown as DataTransferObject;
    }
}
